<template>

	<div class="news-archive">
		<banner v-if="bannerBackgroundImage" class="news-archive__banner header--additive-padding" :backgrounds="bannerBackgroundImage">

			<btn v-if="bannerCta" class="news-archive__banner-btn" :link="bannerCta.url">
				<span v-html="bannerCta.text"></span>
			</btn>

		</banner>


		<template :if="news.length > 0">
			<div  class="panel pt--32c pb--48c" :class="{
				'header--additive-padding': !bannerBackgroundImage,
			}">
				<div class="page-container">
					<h2 class="h3 heading--black mb--24c">Categories</h2>
				</div>

				<div class="news-archive__categories" v-dragscroll>
					<div class="page-container">
						<div class="grid grid--g16 grid--s0 grid--auto grid--nowrap grid--middle">
							<div class="grid__item news-archive__category-wrap">

								<Btn class="btn--style--custom news-archive__category" :class="{
									'news-archive__category--active': categoryFilter == null
								}" @click.native="categoryFilter = null">All</Btn>

							</div>
							<div v-for="(cat, slug) in $store.state.app.categories" class="grid__item news-archive__category-wrap">

								<Btn class="btn--style--custom news-archive__category" :class="{
									'news-archive__category--active': categoryFilter == slug
								}" @click.native="categoryFilter = slug">{{cat}}</Btn>

							</div>
						</div>
					</div>
				</div>
			</div>

			<hr />

			<div :if="news.length > 0" class="panel">
				<div class="page-container" ref="containerStart">

					<div class="panel__title">
						<h2 class="h3 heading--black" v-html="title"></h2>
						<h3 class="h4 fc-pal--grey" v-html="description"></h3>
					</div>

					<div class="grid">
							<div
								class="grid__item one-third--not-phab one-half--phab"
								v-bind:class="{'hide--phab' : index === 2}"
								v-for="(item, index) in paginatedNews"
								v-bind:key="index"
							>
								<news-overview :news="item"></news-overview>
							</div>
					</div>

					<pagination-controls
						v-if="totalPages > 1"
						v-bind:current-page="compCurrentPage"
						v-bind:total-pages="totalPages"
						v-on:page-change="onPageChange"
					></pagination-controls>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { filter, find, remove, sortBy, orderBy, has, isEmpty } from "lodash";

import Btn from './atoms/Btn'
import Banner from './molecules/Banner'
import NewsOverview from "./molecules/NewsOverview";
import PaginationControls from "./molecules/PaginationControls";

export default {
	name: "NewsArchive",
	components: {
		Btn,
		Banner,
		NewsOverview,
		PaginationControls
	},
	data() {
		return {
			heroData: null,
			news: [],
			currentPage: 1,
			postLimit: 12,
			categoryFilter: null
		};
	},
	computed: {
		bannerBackgroundImage: function()
		{
			if(has(this.heroData, 'desktopBackgroundImage'))
			{
				return {
					mob: this.heroData.mobileBackgroundImage.link,
					ptab: this.heroData.mobileBackgroundImage.link,
					ltab: this.heroData.desktopBackgroundImage.link,
					desk: this.heroData.desktopBackgroundImage.link,
				};
			}

			return null;
		},
		bannerCta: function()
		{
			if(has(this.heroData, 'cta.0.url') && !isEmpty(this.heroData.cta[0].url) && !isEmpty(this.heroData.cta[0].text))
			{
				return this.heroData.cta[0];
			}

			return null;
		},
		title: function()
		{
			switch(this.categoryFilter)
			{
				case 'product':
					return 'Product News';
				case 'feature':
					return 'New Features';
				case 'press-release':
					return 'Press Releases';
				case 'events':
					return 'Events';
				case 'omnia':
					return 'OMNIA';
				default:
					return "All News &amp; Events";
			}
		},
		description: function()
		{
			return "Stay current with the latest IGT news and events.";
		},
		filteredNews()
		{
			if(this.categoryFilter == null) { return this.news; }

			return filter(this.news, news =>
			{
				return news.category == this.categoryFilter;
			});
		},
		paginatedNews()
		{
			var offset = (this.compCurrentPage - 1) * this.postLimit;

			if (offset > this.filteredNews.length) {
				return [];
			}

			return this.filteredNews.slice(offset, offset + this.postLimit);
		},
		totalPages()
		{
			return Math.ceil(this.filteredNews.length / this.postLimit);
		},
		compCurrentPage()
		{
			return Math.max(1, Math.min(this.currentPage, this.totalPages));
		}
	},
	watch: {
		'$root.userSelectedRegionKey': function()
		{
			this.$root.appImmediateLoading = true;

			this.getNewsPosts()
			.then(success =>
			{
				this.$root.appImmediateLoading = false;
			});
		},
	},
	created: function()
	{
		if (this.$route.params.hasOwnProperty("pageNo")) {
			this.currentPage = parseInt(this.$route.params.pageNo);
		}

		if (this.$route.params.hasOwnProperty("category") && this.$store.state.app.categories[this.$route.params.category]) {
			this.categoryFilter = this.$route.params.category;
		}

		this.getPageContent();

		this.getNewsPosts();

	},
	methods: {
		getPageContent: function()
		{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getNewsAndEventsPage(params).then((success) =>
			{
				this.heroData = success.data.content[0];
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},

		getNewsPosts() {
			var self = this;

			// Get all news posts
			var regions = this.$root.userSelectedRegion ? [this.$root.userSelectedRegion.key] : null;
			return self.$api.getNews(null, null, null, null, null, regions)
			.then(data => {
				if (data.hasOwnProperty("data")) {
					self.sortNews(data);
				}
				self.$root.$data.appLoading = false;
			})
			.catch(error => {
				self.$alert.danger({ message: error.message });
			});
		},
		sortNews(data)
		{
			var newsArray = orderBy(data.data.results, ["date"], ["desc"]);

			var today = new Date();
			this.news = newsArray.filter(
//				x => x.status == true && new Date(x.date) <= today
				x => x.status == true
			);
		},
		onPageChange(page)
		{
			this.currentPage = page;
			this.$scrollTo(this.$refs.containerStart, 500, {
				offset: -80
			});
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".news-archive";
	#{$c} {
		&__banner
		{
			min-height: 290px;
			@include media(not-phab) { min-height: 400px; }

			&.banner
			{
				@include extend(vertical-bottom);
				padding: {top: rem(40); bottom: rem(40); }
				@include media(not-phab) { padding: {top: rem(56); bottom: rem(56); } }
			}

			.banner__content
			{
				text-align: center;
			}

			&-btn
			{
				&[disabled]
				{
					background-color: palette(grey);
					opacity: 0.9;
				}
			}
		}

		&__categories
		{
			overflow: hidden;
		}

		&__category-wrap
		{
			&:last-child
			{
				padding-right: $page-padding;
			}
		}

		&__category
		{
			@include extend(btn);
			@include extend(btn--style--stroke);
			@include extend(btn--style--stroke--light-grey);
			padding-left: rem(24);
			padding-right: rem(24);
			color: palette('grey');
			border-width: 1px;

			&:after
			{
				height: 46px;
			}

			&--active
			{
				color: palette('font');
				border-color: currentColor;
				box-shadow: inset 0 0 0 1px palette('font');
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NewsArchive.vue